import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import ItemModify from '../Form/ItemModify';

@inject('locationTypeStore')
@observer
class LocationTypeModify extends Component {
  render() {
    const { locationTypeStore, params} = this.props;

    return (
      <ItemModify
      title='Location Type'
      slug = '/configurations/location/location-type'
      store = {locationTypeStore}
      itemFields = {[
        { label: 'Id', key: 'id', type: 'text', readOnly : true, editOnly : true},
        { label: 'Name', key: 'name', type: 'text' },
        { label: 'Description', key: 'description', type: 'text' },
        { label: 'Parent Location', key: 'parent_location', type: 'select', options: locationTypeStore.items,  fields:{label: 'name', value: 'id'}  },
      ]}
      params={params}
      />
    );
  }
}

export default LocationTypeModify;



// WEBPACK FOOTER //
// ./src/components/Location/LocationTypeModify.js